import { useState } from 'react';

export interface ModalType<TypeT = string, DataT = any> {
  open: boolean;
  type?: 'VIEW' | 'ADD' | 'UPDATE' | 'DELETE' | 'ACTION' | TypeT;
  data?: DataT;
}

export default function useDiscloser<TypeT extends string = never, DataT = any>(
  reRender?: () => void,
) {
  const [config, setConfig] = useState<ModalType<TypeT, DataT>>({
    open: false,
  });

  const openModal = <T extends DataT>(
    params: Omit<ModalType<TypeT, T>, 'open'>,
  ) => {
    setConfig({ open: true, ...params });
  };

  const closeModal = (shouldReload?: boolean) => {
    if (shouldReload && reRender) reRender();
    setConfig({ open: false });
  };

  return [config, openModal, closeModal] as const;
}
